type prefix = {
    name?: {
        th?: string
        en?: string
    }
    academicPosition?: {
        th?: string
        en?: string
    }
    titleID?: number | null
    title?: {
        th?: string
        en?: string
    }
    isPhD?: boolean
}

export const setPrefixName = ({ name, academicPosition, titleID, title, isPhD }: prefix) => {
    const drTH = 'ดร.'
    const drEN = 'Dr.'

    let result = {
        th: '',
        en: '',
    }

    //th
    if (academicPosition?.th && isPhD) {
        result.th = `${academicPosition?.th} ${drTH}${name?.th}`
    }

    if (academicPosition?.th && !isPhD) {
        result.th = `${academicPosition?.th} ${name?.th}`
    }

    if (academicPosition?.th === null && isPhD) {
        result.th = `${drTH}${name?.th}`
    }

    if (academicPosition?.th === null && !isPhD && titleID) {
        result.th = `${title?.th}${name?.th}`
    }

    if (academicPosition?.th === null && !isPhD && titleID === null && title?.th) {
        result.th = `${title?.th}${name?.th}`
    }

    if (academicPosition?.th === null && !isPhD && titleID === null && title?.th === null) {
        result.th = `${name?.th}`
    }

    //en
    if (academicPosition?.en && isPhD) {
        result.en = `${academicPosition?.en} ${drEN}${name?.en}`
    }

    if (academicPosition?.en && !isPhD) {
        result.en = `${academicPosition?.en} ${name?.en}`
    }

    if (academicPosition?.en === null && isPhD) {
        result.en = `${drEN}${name?.en}`
    }

    if (academicPosition?.en === null && !isPhD && titleID) {
        result.en = `${title?.en}${name?.en}`
    }

    if (academicPosition?.en === null && !isPhD && titleID === null && title?.en) {
        result.en = `${title?.en}${name?.en}`
    }

    if (academicPosition?.en === null && !isPhD && titleID === null && title?.en === null) {
        result.en = `${name?.en}`
    }

    return result
}
